import { EndpointSetting } from "@/constants/app/type"

// baseAxios unwraps `response.data.data`; when that value is an array it gets
// spread into a numeric-keyed object ({0:..,1:..}), so rebuild the array here.
// Also tolerate the raw array or the full envelope leaking through.
export const callbackBlogList: EndpointSetting["caller"] = (state, action) => {
  const payload = action.payload

  if (Array.isArray(payload)) {
    state.blog_list.data = payload
    return
  }
  if (Array.isArray(payload?.data)) {
    state.blog_list.data = payload.data
    return
  }
  if (payload && typeof payload === "object") {
    // Numeric-keyed object from the array spread — keep only blog-like entries
    state.blog_list.data = Object.values(payload).filter(
      (v: any) => v && typeof v === "object" && ("id" in v || "slug" in v),
    )
    return
  }
  state.blog_list.data = []
}
